export const CONTACTS = {
  phoneDisplay: "+39 340 384 5845",
  phoneHref: "tel:+393403845845",
  whatsapp:
    "https://wa.me/393403845845?text=" +
    encodeURIComponent(
      "Ciao Sprizziamoci! Vorrei un preventivo per il mio evento."
    ),
};

export const SUPPLIER = {
  name: "Pasquini SRL",
  url: "https://www.pasquinisrl.it/",
  tag: "Fornitore ufficiale",
  desc: "Da oltre 40 anni partner per la distribuzione di bevande e impianti di spillatura per l'Ho.Re.Ca: le bevande alla spina e la tecnologia degli erogatori viaggiano con un fornitore di settore.",
  brands: ["Alisea", "Falkenturm", "L'Italica", "Mambo", "Movida", "Pysares", "Vikingen"],
  brandsNote:
    "Birre dei marchi distribuiti da Pasquini, disponibili alla spina in base alla configurazione dell'impianto.",
};

export const IMG = {
  hero: "/gazebo.jpg",
  gazebo: "/gazebo.jpg",
  truck: "/truck-lato.jpg",
  truckFront: "/truck-fronte.jpg",
  truckWrap: "/truck-wrap.jpg",
  banco: "/banco-orig.jpg",
  prosecco:
    "https://images.pexels.com/photos/20303995/pexels-photo-20303995.jpeg?auto=compress&cs=tinysrgb&w=1000",
  logo: "/logo.png",
  pour:
    "https://images.unsplash.com/photo-1744481417845-a1576455b5a4?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format&fit=crop&w=1200",
  dimBar:
    "https://images.unsplash.com/photo-1567696911980-2eed69a46042?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format&fit=crop&w=1200",
  jigger:
    "https://images.pexels.com/photos/5530263/pexels-photo-5530263.jpeg?auto=compress&cs=tinysrgb&w=1200",
  tapHandle:
    "https://images.unsplash.com/photo-1555658636-6e4a36218be7?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format&fit=crop&w=1200",
  beerDispensers:
    "https://images.unsplash.com/photo-1567696911980-2eed69a46042?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format&fit=crop&w=1200",
  beerPour:
    "https://images.pexels.com/photos/14823758/pexels-photo-14823758.jpeg?auto=compress&cs=tinysrgb&w=1200",
  negroni:
    "https://images.pexels.com/photos/27851286/pexels-photo-27851286.jpeg?auto=compress&cs=tinysrgb&w=1000",
  cola:
    "https://images.pexels.com/photos/33469209/pexels-photo-33469209.jpeg?auto=compress&cs=tinysrgb&w=1000",
  dispensersRow:
    "https://images.pexels.com/photos/32659128/pexels-photo-32659128.jpeg?auto=compress&cs=tinysrgb&w=1200",
  limeIce:
    "https://images.unsplash.com/photo-1783286972545-d84b45ac57a1?q=85&auto=format&fit=crop&w=1200",
  glassesIce:
    "https://images.pexels.com/photos/3769137/pexels-photo-3769137.jpeg?auto=compress&cs=tinysrgb&w=1000",
  weddingTable:
    "https://images.unsplash.com/photo-1782038522729-47b97948ab11?q=85&auto=format&fit=crop&w=1200",
  weddingGarden:
    "https://images.pexels.com/photos/30206423/pexels-photo-30206423.jpeg?auto=compress&cs=tinysrgb&w=1200",
  weddingGlass:
    "https://images.unsplash.com/photo-1782038521626-78eb3c6d5a9e?q=85&auto=format&fit=crop&w=1200",
  friendsToast:
    "https://images.pexels.com/photos/36474955/pexels-photo-36474955.jpeg?auto=compress&cs=tinysrgb&w=1200",
  groupWine:
    "https://images.unsplash.com/photo-1699730164892-d7c433524ff3?q=85&auto=format&fit=crop&w=1200",
  twoGirls:
    "https://images.unsplash.com/photo-1485872299829-c673f5194813?q=85&auto=format&fit=crop&w=1200",
  corpNet:
    "https://images.unsplash.com/photo-1515169067868-5387ec356754?q=85&auto=format&fit=crop&w=1200",
  corpChampagne:
    "https://images.pexels.com/photos/16408/pexels-photo.jpg?auto=compress&cs=tinysrgb&w=1200",
  corpRoom:
    "https://images.unsplash.com/photo-1563461661026-49631dd5d68e?q=85&auto=format&fit=crop&w=1200",
  publicLanterns:
    "https://images.unsplash.com/photo-1762775663613-b90363662977?q=85&auto=format&fit=crop&w=1200",
  bancoEvento: "/banco-evento-pubblico.jpg",
  weddingBanco: "/wedding-banco.jpg",
  bancoErogatori: "/banco-erogatori.jpg",
  publicMarket:
    "https://images.pexels.com/photos/15303871/pexels-photo-15303871.jpeg?auto=compress&cs=tinysrgb&w=1200",
  publicStreet:
    "https://images.unsplash.com/photo-1474513312726-8d86a8bcbaec?q=85&auto=format&fit=crop&w=1200",
  spritz1:
    "https://images.unsplash.com/photo-1570598912132-0ba1dc952b7d?q=85&auto=format&fit=crop&w=1000",
  spritzRow:
    "https://images.pexels.com/photos/36791051/pexels-photo-36791051.jpeg?auto=compress&cs=tinysrgb&w=1000",
  spritzTable:
    "https://images.unsplash.com/photo-1560512823-829485b8bf24?q=85&auto=format&fit=crop&w=1000",
  campari:
    "https://images.unsplash.com/photo-1778104960251-b1d82ac92ee9?q=85&auto=format&fit=crop&w=1000",
  gintonic:
    "https://images.pexels.com/photos/7841374/pexels-photo-7841374.jpeg?auto=compress&cs=tinysrgb&w=1000",
  ginlemon:
    "https://images.unsplash.com/photo-1453825012366-3738046cb6c7?q=85&auto=format&fit=crop&w=1000",
};

export const SLOGANS = [
  "Dal primo brindisi all'ultimo cocktail",
  "Tu goditi la festa, al resto pensiamo insieme",
  "Accendi la festa",
  "Un banco. Mille occasioni per brindare",
  "L'aperitivo si mette in viaggio",
  "Il prossimo brindisi è tuo",
];

export const STRENGTHS = [
  {
    n: "01",
    title: "Una postazione che si fa notare.",
    text: "Gazebo e banconi con grafica originale nera e arancione: l'allestimento Sprizziamoci si riconosce a colpo d'occhio e diventa il cuore visivo della festa.",
  },
  {
    n: "02",
    title: "Un servizio organizzato e dedicato.",
    text: "Impianto di spillatura, ghiaccio, bicchieri e materiale di consumo: arriviamo, installiamo e teniamo la postazione rifornita per tutta la durata dell'evento.",
  },
  {
    n: "03",
    title: "Un allestimento che si adatta all'evento.",
    text: "Energico per una festa, raffinato per un matrimonio: la postazione cambia veste con rivestimenti, luci e dettagli coordinati all'occasione.",
  },
];

export const SELF_LINE =
  "La particolarità di Sprizziamoci è l'autonomia: i tuoi ospiti si servono da soli, senza attese e senza limiti nel consumo del beverage. Cocktail pre-mix, birre e analcolici alla spina: nessun operatore che serve, solo rubinetti, ghiaccio e bicchieri sempre pronti.";

export const ALLESTIMENTI_VARIANTS = [
  {
    n: "01",
    name: "Elegante & classico",
    desc: "Stile senza tempo, per dimore storiche.",
    image: "/allestimento-1.jpg",
  },
  {
    n: "02",
    name: "Rustico moderno",
    desc: "Legno di recupero, materiali naturali, charm autentico.",
    image: "/allestimento-2.jpg",
  },
  {
    n: "03",
    name: "Minimal & moderno",
    desc: "Linee pulite, colori neutri, eleganza contemporanea.",
    image: "/allestimento-3.jpg",
  },
  {
    n: "04",
    name: "Boho-vintage",
    desc: "Atmosfere calde, colori naturali, dettagli unici.",
    image: "/allestimento-4.jpg",
  },
];

export const EVENTS = [
  {
    slug: "wedding",
    path: "/wedding",
    label: "Wedding",
    badge: "Servizio dedicato",
    cardTitle: "Il vostro sì merita un brindisi speciale.",
    short:
      "Aperitivo di cerimonia, welcome drink, cocktail hour e feste serali: il banco indossa la veste elegante effetto legno.",
    image: IMG.weddingBanco,
    cta: "Crea il tuo wedding aperitivo",
    seoTitle: "Wedding: aperitivo e cocktail bar per matrimoni | Sprizziamoci",
    seoDesc:
      "Welcome drink, aperitivo di cerimonia e cocktail hour con il banco Sprizziamoci in versione elegante: effetto legno, luci ambrate, ombrellone avorio.",
  },
  {
    slug: "feste-private",
    path: "/feste-private",
    label: "Feste private",
    badge: "Servizio dedicato",
    cardTitle: "Le occasioni passano. I brindisi restano.",
    short:
      "Compleanni, lauree, anniversari e feste in casa, in villa o in giardino: portiamo l'angolo bar dove c'è la festa.",
    image: IMG.friendsToast,
    cta: "Facciamo festa",
    seoTitle: "Feste private: compleanni, lauree e feste in casa | Sprizziamoci",
    seoDesc:
      "Banco di mescita professionale per compleanni, lauree, anniversari e feste private in casa, ville e giardini. Cocktail e bevande alla spina al tuo evento.",
  },
  {
    slug: "eventi-aziendali",
    path: "/eventi-aziendali",
    label: "Eventi aziendali",
    badge: "Servizio dedicato",
    cardTitle: "Il networking incontra l'aperitivo.",
    short:
      "Inaugurazioni, presentazioni, meeting informali e feste aziendali: ordine, immagine professionale e zero pensieri.",
    image: IMG.corpNet,
    cta: "Richiedi una proposta aziendale",
    seoTitle: "Eventi aziendali: beverage per inaugurazioni e meeting | Sprizziamoci",
    seoDesc:
      "Sprizziamoci per inaugurazioni, presentazioni, meeting informali e feste aziendali: servizio beverage professionale, personalizzato e organizzato.",
  },
  {
    slug: "eventi-pubblici",
    path: "/eventi-pubblici",
    label: "Eventi pubblici",
    badge: "Partnership socio",
    cardTitle: "Dove c'è gente, c'è voglia di brindare.",
    short:
      "Manifestazioni, festival, feste di piazza ed eventi musicali: un banco riconoscibile e postazioni dedicate al flusso di pubblico.",
    image: IMG.bancoEvento,
    cta: "Diventa partner socio",
    seoTitle: "Eventi pubblici e manifestazioni: cocktail bar itinerante | Sprizziamoci",
    seoDesc:
      "Il banco Sprizziamoci per festival, feste di piazza, eventi musicali e manifestazioni: riconoscibilità, rapidità operativa e postazioni dedicate al pubblico.",
  },
];

export const STEPS = [
  {
    n: "01",
    title: "Raccontaci il tuo evento.",
    text: "Indicaci data, luogo, tipologia di festa, numero di invitati e durata desiderata.",
  },
  {
    n: "02",
    title: "Personalizziamo la proposta.",
    text: "Definiamo bevande, quantità e allestimento: prodotto, personale di servizio e ghiaccio sono inclusi.",
  },
  {
    n: "03",
    title: "Arriviamo e prepariamo la postazione.",
    text: "Organizziamo banco, ghiaccio, bicchieri e le attrezzature comprese nel pacchetto.",
  },
  {
    n: "04",
    title: "Si apre il servizio.",
    text: "La postazione viene gestita secondo gli accordi, con rifornimento e assistenza operativa per la durata prevista.",
  },
];

export const COCKTAILS = [
  { name: "Spritz Classico", image: IMG.spritz1, alt: "Spritz Classico con arancia e ghiaccio" },
  { name: "Spritz Bitter", image: IMG.campari, alt: "Spritz Bitter con fetta d'arancia" },
  { name: "Negroni", image: IMG.negroni, alt: "Negroni con scorza d'arancia" },
  { name: "Gin Tonic", image: IMG.gintonic, alt: "Gin Tonic con agrumi e ghiaccio" },
  { name: "Gin Lemon", image: IMG.ginlemon, alt: "Gin Lemon con fettina di limone" },
];

export const TAP_EXTRA = {
  birra: {
    title: "Birra alla spina",
    text: "Bionda, rossa, scura e speciali: sempre fredda e alla spina.",
    image: IMG.beerPour,
    alt: "Birra versata alla spina nel bicchiere",
  },
  analcolici: {
    title: "Analcolici",
    text: "Coca Cola, Fanta, Sprite, Schweppes, succhi e altre bevande.",
    image: IMG.cola,
    alt: "Bicchiere di analcolico con ghiaccio",
  },
  vino: {
    title: "Vino e Prosecco",
    text: "Il tocco in più per l'aperitivo e i brindisi.",
    image: IMG.prosecco,
    alt: "Calice di prosecco colmo di bollicine",
  },
};

export const GALLERY_CATS = [
  { id: "tutti", label: "Tutti" },
  { id: "wedding", label: "Wedding" },
  { id: "feste-private", label: "Feste private" },
  { id: "eventi-aziendali", label: "Eventi aziendali" },
  { id: "eventi-pubblici", label: "Eventi pubblici" },
  { id: "attrezzature", label: "Attrezzature e allestimenti" },
];

export const GALLERY = [
  { src: IMG.truck, cat: "attrezzature", alt: "Il mezzo operativo Sprizziamoci: il food truck dell'aperitivo on the road", ratio: "aspect-[6/5]" },
  { src: IMG.truckFront, cat: "attrezzature", alt: "Il food truck Sprizziamoci, vista frontale con la grafica del brand", ratio: "aspect-[2/3]" },
  { src: "/gazebo.jpg", cat: "attrezzature", alt: "L'allestimento originale Sprizziamoci: gazebo nero e arancione con area self service e banconi con erogatori", ratio: "aspect-[4/3]" },
  { src: "/banco-wedding.jpg", cat: "wedding", alt: "Il banco Sprizziamoci in allestimento wedding: effetto legno, ombrellone avorio e luci ambrate", ratio: "aspect-square" },
  { src: IMG.weddingTable, cat: "wedding", alt: "Tavola apparecchiata con calici e fiori per un ricevimento di matrimonio", ratio: "aspect-[4/5]" },
  { src: IMG.weddingGarden, cat: "wedding", alt: "Bottiglie in raffreddamento in un secchio di ghiaccio in giardino", ratio: "aspect-[4/5]" },
  { src: IMG.weddingGlass, cat: "wedding", alt: "Calice alzato durante un brindisi all'aperto", ratio: "aspect-[4/5]" },
  { src: IMG.friendsToast, cat: "feste-private", alt: "Gruppo di amici che brinda di sera", ratio: "aspect-[4/5]" },
  { src: IMG.groupWine, cat: "feste-private", alt: "Invitati che alzano i bicchieri alla festa", ratio: "aspect-[4/5]" },
  { src: IMG.twoGirls, cat: "feste-private", alt: "Amiche conversano con un drink in mano", ratio: "aspect-[4/5]" },
  { src: IMG.corpNet, cat: "eventi-aziendali", alt: "Ospiti in conversazione durante un ricevimento aziendale", ratio: "aspect-[4/5]" },
  { src: IMG.corpChampagne, cat: "eventi-aziendali", alt: "Calici in fila su un vassoio durante un evento", ratio: "aspect-[4/5]" },
  { src: IMG.corpRoom, cat: "eventi-aziendali", alt: "Networking tra professionisti durante un evento", ratio: "aspect-[4/5]" },
  { src: IMG.publicLanterns, cat: "eventi-pubblici", alt: "Folla sotto lanterne illuminate in una festa serale", ratio: "aspect-[4/5]" },
  { src: IMG.publicMarket, cat: "eventi-pubblici", alt: "Vicolo affollato durante una manifestazione", ratio: "aspect-[4/5]" },
  { src: IMG.banco, cat: "attrezzature", alt: "Il banco originale Sprizziamoci con gli erogatori per spritz, campari, gin tonic e gin lemon e la modula analcolici Pasquini", ratio: "aspect-[3/4]" },
  { src: IMG.limeIce, cat: "attrezzature", alt: "Preparazione con agrumi freschi e ghiaccio", ratio: "aspect-[4/5]" },
  { src: IMG.dimBar, cat: "attrezzature", alt: "Erogatori per bevande pre-mix e birra alla spina", ratio: "aspect-[4/5]" },
  { src: IMG.pour, cat: "attrezzature", alt: "Un ospite si serve da solo alla spina", ratio: "aspect-[4/5]" },
  { src: IMG.beerPour, cat: "attrezzature", alt: "Birra alla spina versata nel bicchiere", ratio: "aspect-[4/5]" },
  { src: IMG.dispensersRow, cat: "attrezzature", alt: "File di erogatori per bevande in self service", ratio: "aspect-[4/5]" },
];

export const PARTNER_AUDIENCES = [
  "Wedding planner",
  "Catering e banqueting",
  "Location per matrimoni",
  "Organizzatori di eventi",
  "Agenzie di comunicazione ed eventi",
  "Pro Loco, associazioni e organizzatori di manifestazioni",
  "Aziende e operatori del settore hospitality",
];

export const PARTNER_POINTS = [
  { title: "Collaborazioni B2B", text: "Un servizio beverage che si integra nella tua proposta al cliente." },
  { title: "Formule personalizzabili", text: "Prodotti, consumabili e personale secondo la formula concordata." },
  { title: "Allestimenti adattabili", text: "Dalla grafica originale alla veste elegante effetto legno." },
  { title: "White label o co-branded", text: "Possibilità da concordare, evento per evento." },
  { title: "Preventivi per operatori", text: "Condizioni dedicate per collaborazioni ricorrenti." },
];
